import { MDBCardHeader, MDBIcon } from "mdbreact";

const Header = () => {
  return (
    <MDBCardHeader className="d-flex justify-content-between align-items-center flex-wrap">
      <div>
        <h4 className="mb-1">
          <MDBIcon icon="download" className="mr-2 text-primary" />
          Analyzer Bridge Downloads
        </h4>
        <small className="text-muted">
          Browse available bridge packages for Service Engineer deployment.
        </small>
      </div>
    </MDBCardHeader>
  );
};

export default Header;
